import Close from '@mui/icons-material/Close';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { exitImpersonationMode } from '../../store/slices/authSlice';

const previewBranch = import.meta.env.VITE_PREVIEW_BRANCH;

const Ribbon = memo(({ sidebarOpen }) => {
  const dispatch = useDispatch();
  const isImpersonationMode = useSelector(({ auth }) => auth.isImpersonationMode);

  const widthClass = sidebarOpen ? 'w-[calc(100%-270px)] ml-[270px]' : 'w-full';

  return (
    <>
      {previewBranch && (
        <div className={classNames('flex items-center justify-center py-2 bg-[#E65100] gap-2', widthClass)}>
          <p className='text-[#fff] text-[13px] font-medium'>
            Preview Environment —{' '}
            <code className='bg-[rgba(0,0,0,0.2)] px-1.5 py-0.5 rounded text-[12px]'>{previewBranch}</code>
          </p>
        </div>
      )}
      {isImpersonationMode && (
        <div className={classNames('flex items-center justify-center py-4 bg-[#1B4332] gap-4', widthClass)}>
          <p className='text-[#fff]'>You are currently in Impersonation Mode</p>
          <button
            className='flex items-center justify-center gap-1 py-1 px-4 rounded-full bg-[#fff] text-[#1B4332] text-[14px] font-semibold hover:scale-[1.03]'
            onClick={() => dispatch(exitImpersonationMode())}
          >
            Exit Impersonation Mode <Close sx={{ fill: '#1B4332', width: '16px' }} />
          </button>
        </div>
      )}
    </>
  );
});

Ribbon.propTypes = {
  sidebarOpen: PropTypes.bool,
};

export default Ribbon;
